import React from "react";

/**
 * Блок-заглушка по центру страницы/секции.
 * @param {{ className?: string, label?: string }} [props]
 */
export function PageLoader({ className = "", label = "Загрузка" }) {
  return (
    <div
      className={`pageLoader ${className}`.trim()}
      role="status"
      aria-label={label}
    >
      <div className="appSpinner" aria-hidden />
    </div>
  );
}

/**
 * Спиннер для кнопок: без текста, подставляется вместо подписи при загрузке.
 * @param {{ className?: string, label?: string }} [props]
 */
export function InlineLoader({ className = "", label = "Загрузка" }) {
  return (
    <span
      className={`appSpinner appSpinner--inline ${className}`.trim()}
      role="status"
      aria-label={label}
    />
  );
}
